import { Button } from './Button';
import { Container } from './Container';
import { useScrollReveal } from './useScrollReveal';
import { trackEvent } from '../utils/analytics';
import { useUser } from '../userContext';
import { useSignupModal } from './SignupModalContext';

const BULLETS = [
  'Your first published game is free, with every feature unlocked.',
  '£39 per game after that. Buy as you ship, no subscription.',
  '5-game pack at £149 (~£30 per game) for agencies and repeat campaign teams.',
  'Editing a published game stays free forever.',
];

export function Pricing() {
  const [revealRef, isVisible] = useScrollReveal();
  const { user } = useUser();
  const { openSignupModal } = useSignupModal();

  const isSignedIn = !!user;

  const handleStart = () => {
    trackEvent('pricing_cta_clicked', { signedIn: isSignedIn });
    openSignupModal();
  };

  return (
    <section
      ref={revealRef}
      id="pricing"
      aria-label="Pricing"
      className={`sf-section sf-section-commercial py-10 sm:py-16 landing-reveal ${isVisible ? 'visible' : ''}`}
    >
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-arcade text-3xl tracking-tight text-gch-accent sm:text-4xl">
            Free first game. £39 each after.
          </h2>
          <p className="mt-3 text-base text-gch-text-secondary">
            Pay only when you ship. No subscription, no plans.
          </p>

          <ul className="mt-8 space-y-3 text-left mx-auto max-w-md">
            {BULLETS.map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm text-gch-text-secondary">
                <span className="mt-1.5 inline-block w-1.5 h-1.5 rounded-full bg-gch-accent shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex justify-center">
            <Button onClick={handleStart} className="justify-center">
              Start free
            </Button>
          </div>

          <p className="mt-6 text-xs text-gch-text-muted">
            Refunds at support@smilesflow.com.
          </p>
        </div>
      </Container>
    </section>
  );
}
